export default __webpack_public_path__ + "static/media/ProcoreBlackLogo.afe16d96.png";